import decryptManifest from "./lib/decrypt-manifest.browser.js";
import StickersClientFactory from "./lib/stickers-client.js";
const { getStickerPackManifest, getStickerInPack, getEmojiForSticker } = StickersClientFactory({
  decryptManifest,
  base64Encoder: btoa
});
export {
  getEmojiForSticker,
  getStickerInPack,
  getStickerPackManifest
};
//# sourceMappingURL=browser.js.map
